import { z } from 'zod';
import { DecimalJSLikeSchema } from "../inputTypeSchemas/DecimalJsLikeSchema"
import { isValidDecimalInput } from "../inputTypeSchemas/isValidDecimalInput"

/////////////////////////////////////////
// MATERIAL SCHEMA
/////////////////////////////////////////

export const MaterialSchema = z.object({
  materialId: z.number().int(),
  cityId: z.number().int(),
  caseId: z.number().int(),
  qtyMaterial: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'qtyMaterial' must be a Decimal. Location: ['Models', 'Material']",  }),
  details: z.string(),
  unitMaterial: z.string(),
  unitCostMaterial: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'unitCostMaterial' must be a Decimal. Location: ['Models', 'Material']",  }),
  vendorMaterial: z.string(),
  typeMaterial: z.string(),
  dateMaterial: z.coerce.date(),
  materialCost: z.union([z.number(),z.string(),DecimalJSLikeSchema,]).refine((v) => isValidDecimalInput(v), { message: "Field 'materialCost' must be a Decimal. Location: ['Models', 'Material']",  }),
})

export type Material = z.infer<typeof MaterialSchema>

export default MaterialSchema;
